<template>
  <div>
    <el-button :type="buttonType" :size="buttonSize" @click="openWindow">{{
      buttonText
    }}</el-button>
    <el-dialog
      append-to-body
      title="选择资产"
      :visible.sync="deviceVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="45%"
    >
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="所属单位" v-if="!isMarket">
          <el-cascader
            v-model="formInline.companyCode"
            :disabled="isSelect"
            style="width: 140px"
            :options="options"
            :props="props1"
            clearable
            :show-all-levels="false"
            filterable
            placeholder="请选择单位"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="formInline.statue"
            style="width: 150px"
            placeholder="请选择状态"
            clearable
          >
            <el-option
              v-for="item in deviceStatuData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模糊搜索">
          <el-input
            v-model="formInline.content"
            placeholder="搜索内容"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="findAll">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="deviceTable"
        id="deviceTable"
        :row-key="getRowKeys"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="300"
        size="mini"
        @selection-change="changeCheckBoxValue"
      >
        <el-table-column type="selection" :reserve-selection="true" :selectable="checkSelectable" width="55">
        </el-table-column>
        <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="zcbh" label="资产编号" width="120">
        </el-table-column>
        <el-table-column prop="zcmc" label="资产名称" width="120">
        </el-table-column>
        <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sbzt" label="设备状态" show-overflow-tooltip>
          <template slot-scope="scope" show-overflow-tooltip>
            <span v-if="scope.row.sbzt == '1'" style="color: gray">准用</span>
            <span v-else-if="scope.row.sbzt == '4'" style="color: orange"
              >报废</span
            >
            <span v-else-if="scope.row.sbzt == '40'" style="color: orange"
              >待维保</span
            >
            <span v-else-if="scope.row.sbzt == '41'" style="color: orange"
              >停用(待检定)</span
            >
            <span v-else-if="scope.row.sbzt == '42'" style="color: orange"
              >调拨</span
            >
            <span v-else-if="scope.row.sbzt == '43'" style="color: orange"
              >停用(待校准)</span
            >
            <span v-else-if="scope.row.sbzt == '44'" style="color: orange"
              >停用(待核查)</span
            >
            <span
              v-else-if="scope.row.sbzt == '45'"
              style="color: orange"
            ></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="borrow_status"
          label="借用状态"
          show-overflow-tooltip
          v-if="isMarket"
        >
          <template slot-scope="scope" show-overflow-tooltip>
            <span
              v-if="scope.row.borrow_status == '0'"
              style="color: gray"
              >可借</span
            >
            <span v-else style="color: orange">不可借</span>
          </template>
        </el-table-column>
      </el-table>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination
          v-if="tableData.length > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="transmit">选择</el-button>
        <el-button @click="guanbi">关闭</el-button>
      </span>
      <!-- 添加显示购物车按钮，如果复选框有选中让显示，否则不显示 -->
      <div
        style="
          position: fixed;
          top: 61%;
          left: 30%;
          height: 50px;
          width: 50px;
          color: #4095e5;
          font-size: 20px;
        "
        @click="checkBoxdialog = true"
        v-if="checkBoxData.length > 0"
      >
        <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
        <el-badge :value="checkBoxNumber">
          <img
            src="../../../static/img/selects.png"
            style="width: 70%; height: 70%; font-size: 40px"
          />
          <!-- <span class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></span> -->
        </el-badge>
      </div>
      <!-- 显示购物车列表 -->
      <el-dialog
        title="已选择设备"
        :visible.sync="checkBoxdialog"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-button
          type="primary"
          size="mini"
          @click="removeAllCheckbox"
          style="margin-top: -30px; float: left"
          >清空内容</el-button
        >
        <el-table
          :data="checkBoxData"
          v-if="checkBoxNumber > 0"
          :header-cell-style="{ background: '#eff3f6' }"
          style="padding-top: 5px"
        >
          <el-table-column
            type="index"
            label="序号"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column property="glbh" label="管理编号"></el-table-column>
          <el-table-column property="zcmc" label="资产名称"></el-table-column>
          <el-table-column property="zcbh" label="资产编号"></el-table-column>
          <el-table-column property="sbxh" label="设备型号"></el-table-column>
          <el-table-column label="操作" style="text-decoration: none">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="removeThisData(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import {
  treeCompany,
  selectAvailableDevice,
  getStatueByDevice,
} from "../../api/api";
export default {
  name: "MultipleDevices",
  props: {
    transferValue: Function,
    personInfo: Object,
    buttonType: {
      type: String,
      default: "primary",
    },
    buttonText: {
      type: String,
      default: "选择资产",
    },
    buttonSize: {
      type: String,
      default: "small",
    },
    rowInfo: {
      type: Object,
      default: null,
    },
    parameter: {
      type: Object,
      default: null,
    },
    isMarket: {
      type: Boolean,
      default: false,
    },
    initialSelected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formInline: {
        content: "",
        statue: "",
        companyCode: "",
      },
      props1: {
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        expandTrigger: "click",
        emitPath: false,
      },
      disabled: "",
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      deviceVisible: false,
      tableData: [],
      deviceTable: [],
      options: [],
      outData: {},
      checkBoxdialog: false,
      checkBoxNumber: 0,
      checkBoxData: [],
      deviceStatuData: [],
      isSelect: false,
      initialSelectedData: [], // 内部保存的 initialSelected（用于翻页/查询后重新勾选）
    };
  },

  methods: {
    //查找设备状态
    findAllType() {
      getStatueByDevice().then((datas) => {
        let { status, message, data } = datas;
        var list = [];
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].statusType == "设备台账" && data[i].id != 3) {
              list.push({ name: data[i].statusName, id: data[i].id });
            }
          }
          this.deviceStatuData = list;
        }
      });
    },
    getRowKeys(row) {
      return row.id;
    },
    guanbi() {
      this.$refs.deviceTable.clearSelection();
      this.deviceVisible = false;
    },
    //获取复选框选中数据
    changeCheckBoxValue(val) {
      this.checkBoxData = val;
      this.checkBoxNumber = this.checkBoxData.length;
    },
    //清空所有内容
    removeAllCheckbox() {
      this.checkBoxData = [];
      this.checkBoxNumber = this.checkBoxData.length;
      this.$refs.deviceTable.clearSelection(); //清除所有选中复选框
      this.checkBoxdialog = false;
    },
    handleClose(done) {
      this.$refs.deviceTable.clearSelection();
      done();
    },
    //移除一条选中内容
    removeThisData(row) {
      let newCheckBoxData = [];
      for (var i = 0; i < this.checkBoxData.length; i++) {
        if (this.checkBoxData[i].id != row.id) {
          // debugger
          newCheckBoxData.push(this.checkBoxData[i]);
        }
      }
      this.checkBoxData = newCheckBoxData;
      if (this.checkBoxData.length > 0) {
        this.$refs.deviceTable.store.states.selection.map((item, index) => {
          if (item.id === row.id) {
            this.$refs.deviceTable.store.states.selection.splice(index, 1);
          }
        });
      } else {
        this.$refs.deviceTable.clearSelection(); //清除所有选中复选框
        this.checkBoxdialog = false;
      }
      this.checkBoxNumber = this.checkBoxData.length;
    },
    openWindow() {
      this.deviceVisible = true;
      // 复制 initialSelected 到内部状态（用于翻页/查询后重新勾选）
      this.initialSelectedData = (this.initialSelected || []).map(d => ({ ...d }));
      var user = JSON.parse(localStorage.getItem("user"));
      if (
        user.userRole == 1 ||
        (user.companyCode != null && user.companyCode == "G065")
      ) {
        // this.formInline.companyCode=""
      } else {
        (this.isSelect = true),
          (this.formInline.companyCode = user.companyCode);
      }
      this.findAll();
    },
    // 检查行是否可勾选：报废/检定不通过的设备不可选
    checkSelectable(row) {
      return row.sbzt !== 4 && row.sbzt !== '4' && row.sbzt !== 46 && row.sbzt !== '46';
    },
    // 对当前页表格自动勾选 initialSelectedData 里的设备
    toggleInitialSelection() {
      this.$nextTick(() => {
        if (!this.$refs.deviceTable || !this.initialSelectedData.length) return;
        const ids = new Set(this.initialSelectedData.map(d => d.id));
        this.tableData.forEach(row => {
          if (ids.has(row.id) && this.checkSelectable(row)) {
            this.$refs.deviceTable.toggleRowSelection(row, true);
          }
        });
      });
    },
    transmit() {
      let currentSelect = this.$refs.deviceTable.selection;
      // 合并：initialSelectedData（不在当前页的） + 当前 selection
      const ids = new Set(this.initialSelectedData.map(d => d.id));
      const merged = [...this.initialSelectedData];
      currentSelect.forEach(row => {
        if (!ids.has(row.id)) {
          merged.push(row);
        }
      });
      if (merged.length > 0) {
        this.outData = merged;
        this.transferValue(this.outData, this.rowInfo);
        this.deviceVisible = false;
      } else {
        this.$message.error("请选择一条信息"); // .....失败信息
      }
    },
    selectCompany() {
      treeCompany().then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = this.getTreeData1(data);
        }
      });
    },
    getTreeData1(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData1(data[i].zcompany);
        }
      }
      return data;
    },
    //查找所有调拨信息
    findAll() {
      var user = JSON.parse(localStorage.getItem("user"));
      let map = {
        companyCode: this.formInline.companyCode,
        content: this.formInline.content,
        // content: this.formInline.state,
        state: this.formInline.statue,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        userId: user.userId,
      };
      if (this.parameter) {
        Object.assign(map, this.parameter);
      }

      selectAvailableDevice(map).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.tableData = data.list;
          this.total = data.total;
          this.toggleInitialSelection();
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.findAll();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.findAll();
    },
  },
  created() {
    this.selectCompany();
    this.$set(this.formInline, "statue", this.personInfo);
    this.findAllType();
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/common/MultipleDevices.vue